module.exports = __webpack_public_path__ + "static/media/super_pack_fr_hiver_chat.5cb5979b.png";